module.exports = __webpack_public_path__ + "img/1504133080.e8b5359d.jpg";